import { inject } from '@angular/core';
import { ResolveFn, RedirectCommand } from '@angular/router';
import { CompaniesService } from '../services/companies.service';

interface TestflightConfig {
    appName: string;
    logoUrl: string;
    testFlightUrl: string;
}

export const CompanyTestflightConfigResolver: ResolveFn<TestflightConfig | null | RedirectCommand> = (route, state) => {
    const companiesService = inject(CompaniesService);
    const queryParams = route.queryParamMap;
    const companyCode = queryParams.get('c');

    if (companyCode) {
        return companiesService.getTestflightCompanyConfiguration(companyCode);
    }

    return null;
};
